export default {"src":"/_next/static/media/KCC.8540ac8d.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};